<template>
  <section
    class="product-card"
    :class="{ flipped: flipped, 'ts-style': transformStyle }"
  >
    <section class="front" :class="{ 'ts-style': transformStyle }">
      <section class="header">
        <img
          src="/images/icons/hidden.svg"
          v-if="!collection.active"
          class="hidden-icon"
        />
      </section>
      <card-image
        :images="images"
        type="collection"
        class="card-image"
      ></card-image>
      <card-text
        type="collection"
        :name="collection.name"
        :subtitle="collection.subtitle"
        :info="collection.description && collection.description.length > 0"
        @showInfo="showInfo"
      ></card-text>
    </section>
    <section class="back" @click.stop="hideInfo">
      <div class="description">
        <p class="title">{{ collection.name }}</p>
        <p class="text" v-html="collection.description"></p>
      </div>
      <img class="flip-back" src="@/images/icons/flip-back-icon.svg" />
    </section>
  </section>
</template>

<script>
import CardText from '@/features/printstore/children/CardText.vue'
import CardImage from '@/features/printstore/children/CardImage.vue'
import PrintStoreMixin from '@/features/printstore/PrintStoreMixin.js'
import EditCollection from '@/features/printstore/dialogs/EditCollection.vue'
import { getCollection } from '@/features/printstore/PrintStoreApi'

export default {
  name: 'CollectionCard',
  components: {
    CardText,
    CardImage
  },
  props: ['value'],
  data() {
    return {
      flipped: false,
      transformStyle: false,
      collection: this.value
    }
  },
  mixins: [PrintStoreMixin],
  computed: {
    images() {
      if (this.collection.previewImage) {
        // Cover image van de collectie zelf: geen product, dus geen border.
        return [
          {
            id: this.collection.previewImage,
            printStoreId: this.collection.printStoreId,
            border: false
          }
        ]
      } else if (this.collection.products) {
        return this.collection.products.map((product) => {
          return {
            printStoreId: this.collection.printStoreId,
            id: product.previewImage,
            previewTimestamp: product.previewTimestamp,
            border: !!(
              product.displaySpecification &&
              product.displaySpecification.border
            )
          }
        })
      } else if (this.collection.images) {
        return this.collection.images.map((image) => {
          return {
            printStoreId: this.collection.printStoreId,
            id: image,
            border: false
          }
        })
      } else {
        return []
      }
    }
  },
  methods: {
    async modify() {
      const collection = await getCollection(this.collection.id)
      this.$modal.show(
        EditCollection,
        {
          value: collection,
          callback: (model) => {
            this.collection = model
          }
        },
        { width: 480, height: 'auto', scrollable: true }
      )
    },
    remove() {
      this.deleteCollection(this.collection.id, this.collection.name).then(() =>
        this.$emit('removed')
      )
    },
    showInfo() {
      this.flipped = true
      this.transformStyle = true // needed for backface visibility & fixed popup menu
      document.getElementById('card-holder').style.perspective = '2000px'
      setTimeout(() => {
        document.getElementById('card-holder').style.perspective = 'none'
      }, 400)
    },
    hideInfo() {
      this.flipped = false

      document.getElementById('card-holder').style.perspective = '2000px'
      setTimeout(() => {
        this.transformStyle = false
        document.getElementById('card-holder').style.perspective = 'none'
      }, 400)
    }
  }
}
</script>

<style lang="scss" scoped>
.product-card {
  background-color: transparent;
  transition: transform 0.4s, box-shadow 0.4s;

  &.flipped {
    transform: rotateY(180deg);
  }
}

.ts-style {
  transform-style: preserve-3d; // needed for backface visibility & fixed popup menu
}

.front,
.back {
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  position: absolute;
  border-radius: 24px;
  width: 100%;
  height: 100%;
  background: white;
  top: 0;
  left: 0;
  padding: 4px;
}

.back {
  transform: rotateY(180deg);
  overflow: auto;

  .description {
    padding: 12px 10px 30px;
    line-height: 16px;
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .title {
    font-weight: 600;
    padding-bottom: 7px;
  }

  .text {
    overflow: auto;
    white-space: pre-line;
    line-height: normal;
  }

  .flip-back {
    position: absolute;
    bottom: 12px;
    right: 12px;

    path {
      stroke: var(--sub-color);
    }
  }
}

.hidden-icon {
  margin-left: 4px;
  margin-top: 4px;
}
</style>
